<template>
  <div class="homepage-view">

    <section class="section">
      <div class="dc-login">
        <b-container>
          <b-row>
            <b-col sm="12" md="6" lg="4" offset-lg="1">
              <h5 class="vb-heading mb-4">Inserisci la Gift Card e prenota il tuo viaggio</h5>
              <p>Troverai il valore della Gift Card disponibile al momento del pagamento</p>
              <ul class="ml-2">
                <li>Se il Buono ha un valore inferiore al conto finale non potrai pagare la differenza con il tuo credito welfare.</li>
                <li>Se il Buono ha un valore superiore all'ammontare del pagamento, potrai utilizzare il valore residuo per una futura prenotazione.</li>
                <li>Se hai a disposizione più di un Buono, inseriscili nel campo apposito separati da una virgola (es 1CBC0o6aVOl52v1l,DCouhpTek0gy01sd)</li>
              </ul>
            </b-col>
            <discount-code
              :discount_code_url="discount_code_url"
              :name_url="name_url"
              :surname_url="surname_url"
              :email_url="email_url"
            />
          </b-row>
        </b-container>
      </div>
    </section>

    <!--value props list-->
    <section class="section">
      <b-container>
        <point-list-01
          :pl="[
            {
              pl_icon: 'shield',
              pl_title: 'Tutti i servizi per i tuoi viaggi in treno',
              pl_text: 'Un range completo di servizi per organizzare il tuo viaggio in treno: dai biglietti ferroviari alle prenotazioni dei posti a sedere',
            },
            {
              pl_icon: 'happy_pin', 
              pl_title: 'Biglietti ferroviari per il welfare aziendale',
              pl_text: 'Un servizio di biglietteria ferroviaria progettato per i lavoratori delle aziende italiane, dal sito web al servizio di assistenza',
            },
            {
              pl_icon: 'hands',
              pl_title: 'La nostra assistenza ferroviaria',
              pl_text: 'Un team di assistenza italiano con esperienza pluriennale di supporto ai titolari di welfare aziendale per i viaggi in treno',
            },
          ]" />
      </b-container>
    </section>
  </div>
</template>

<script>
import Vue from 'vue' // per VueRecaptcha
import { VueReCaptcha } from 'vue-recaptcha-v3'
import PointList01 from '@library/blocks/point-list-01.vue'
import DiscountCode from '@travelc/components/blocks/discount_code'

export default {
  name: 'homepage-view',

  components: {
    'point-list-01': PointList01,
    'discount-code': DiscountCode,
  },

  props: {
    discount_code_url: {
      type: String,
      default: '',
    },
    name_url: {
      type: String,
      default: '',
    },
    surname_url: {
      type: String,
      default: '',
    },
    email_url: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
    if (this.get_config('recaptcha.enabled')) {
      Vue.use(VueReCaptcha, {
        siteKey: this.get_config('recaptcha.siteKey'),
      })
    }
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>